//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import Main from "./components/Main";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

export default function MainPage() {
    return (
        <Wrap>
            <Header />
            <InnerCon>
                <Main />
            </InnerCon>
            <Footer />
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
